module.exports = __webpack_public_path__ + "img/pay-success.98fc3ba5.gif";